// extracted by mini-css-extract-plugin
export default {"article":"select_article__feEiy","error":"select_error__uGk0j"};